import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { InvestCard } from 'src/components';

import { useAnimatedView } from 'src/hooks/useAnimatedView';

import { BackgroundImage, CardCoinsImage, CocImage, CoinsGraphImage, WavesImage } from 'src/assets';
import './invest.scss';

export const Invest = () => {
  const { t } = useTranslation();

  const ref = useRef();
  const { isVisible } = useAnimatedView(ref);

  return (
    <div className="invest">
      <div className={`invest-content ${isVisible ? 'active-animation' : ''}`} ref={ref}>
        <img className="invest-image" src={WavesImage} alt={WavesImage} />
        <supertitle>{t('invest:supertitle')}</supertitle>
        <h1 className="invest-title">
          <blue-underline>{t('invest:why')}</blue-underline> {t('invest:start')}{' '}
          <blue-text>{t('invest:invest')}</blue-text>
        </h1>
        <div className="invest-content-body">
          <InvestCard
            image={CardCoinsImage}
            title={t('invest:finances')}
            subTitle={t('invest:financesSub')}
          />
          <InvestCard
            image={CocImage}
            title={t('invest:inflation')}
            subTitle={t('invest:inflationSub')}
          />
          <InvestCard
            image={CoinsGraphImage}
            title={t('invest:risks')}
            subTitle={t('invest:risksSub')}
          />
        </div>

        <img src={BackgroundImage} alt={BackgroundImage} className="invest-image-1" />
      </div>
    </div>
  );
};
